export default __webpack_public_path__ + "static/media/flow_arrow.677d666c.svg";